import React, { useState, useLayoutEffect } from "react";
import uuid from "uuid/v1";

const name = "postId";

const ControlComponent = React.forwardRef(({ classNameWrapper, value, onChange, forID }, ref) => {
	const [postId, setId] = useState(value);

	useLayoutEffect(() => {
		if (!postId) {
			const id = uuid();
			setId(id);
			onChange(id);
		}
	}, []);

	return <span ref={ref} id={forID}
		style={{ color: "#b6b6b6", fontWeight: "bold" }}
		className={classNameWrapper}>
		{postId}
	</span>;
});

export default {
	name,
	ControlComponent,
	PreviewComponent: undefined,
};
